<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
// import Input from "@/components/c-input";
// import Select from "@/components/c-select";
import PaymentTerm from "../../../../components/modals/payment-term";
import Loading from "@/components/c-loading";
import i18n from "../../../../i18n";
import { servicehelpers } from "../../../../services/servicehelpers";
import { loanTemplateService } from "../../../../services/paymentservice/loantemplate.service";
import { settingService } from "../../../../services/settingservice/setting.service";
import { paymenttermService } from "../../../../services/paymentservice/paymentterm.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Loan Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    PaymentTerm,
    // Input,
    // Select,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "loan template",
      breadCrumb: {},

      interestWidth: 'col-md-12',
      payShow: false,
      durationShow: false,

      template: {},
      loanTypesList: {},
      decimalCalcTypeList: {},
      valueName: '',
      valueNameEn: '',
      valueLoanType: 0,
      valueDecimalCalcType: 0,
      valueInterest: 0,
      valueDuration: 0,
      valuePay: 0,

    };
  },
  mounted() {

    this.loadingLoanTypeData();
    this.loadingRoundingRuleData();
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  watch: {
      valueLoanType: function(newVal) { 

        if(this.loanTypesList.data) {
          this.loanTypeChanged(newVal);
        }
      }
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      loanTemplateService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.template = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };

          this.valueName = this.template.name;
          this.valueNameEn = this.template.name_en;
          this.valueLoanType = this.template.loan_type_id;
          this.valueDecimalCalcType = this.template.decimal_calc_type_id;
          this.valueInterest = this.template.rate;
          this.valueDuration = this.template.number_month ? this.template.number_month : 0;
          this.valuePay = this.template.monthly_pay ? this.template.monthly_pay : 0;

          if(this.loanTypesList.data) {
            this.loanTypeChanged(this.valueLoanType);
          }


        });
    },

    loadingLoanTypeData: function() {
      settingService.getLoanTypeList()
        .then(response => {
          this.loanTypesList = response;

          this.loanTypeChanged(this.valueLoanType);
          

        });
    },

    loadingRoundingRuleData: function() {

      servicehelpers.getRoundingRuleData().then(response => {
        this.decimalCalcTypeList = response;
      });
    },

    loanTypeChanged: function(value) {
      let loanType = this.loanTypesList.data.find(item => item.id == value);

      if(loanType == null || loanType == undefined) {
        this.interestWidth = `col-md-12`;
        this.payShow = false;
        this.durationShow = false;
      } else {
        this.interestWidth = loanType.status == 1 || loanType.status == 2  ? `col-md-6` : 
                loanType.status == 3  ? `col-md-4` : `col-md-12`  ;

        this.payShow = loanType.status == 1 ? true : false;
        this.durationShow = loanType.status == 2 ? true : false;
      }
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;
      let term = this.$refs['payment-term'].getTerms();

      // console.log(JSON.stringify(term))

      delete term.label;

      if(this.isAdd) {

        // console.log(JSON.stringify(term));
        paymenttermService.insert(term).then(response => {
           if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-schedule"
                });
              } 
            });
           } 
        });
      // } else {
      //   loanTemplateService.update(this.$route.params.id, loanTemplate).then(response => {
      //     if(response.status == 200) {
            
      //       this.$swal.fire({
      //         title: i18n.t('general.success.title'),
      //         text: i18n.t('general.success.message'),
      //         icon: "success",
      //         showCancelButton: true,
      //         confirmButtonColor: "#34c38f",
      //         cancelButtonColor: "#f46a6a",
      //         confirmButtonText: i18n.t('general.success.yes'),
      //         cancelButtonText: i18n.t('general.success.no')
      //       }).then(result => {
      //         if (!result.value) {
      //           this.$router.push(this.$route.query.redirectFrom || {
      //             name: "setting-schedule"
      //           });
      //         } 
      //       });

      //     }
      //   });
      }

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.payment-schedule-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.configuration.payment-schedule-template.text'),
        href: '/setting/schedule',
      }, {
        text: $t('setting.configuration.payment-schedule-template.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.configuration.payment-schedule-template.new') : $t('setting.configuration.payment-schedule-template.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.configuration.payment-schedule-template.text'),
        href: '/setting/schedule',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.configuration.payment-schedule-template.new') : $t('setting.configuration.payment-schedule-template.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />


    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-9">
        <div class="card">
          <div class="card-body">
            <PaymentTerm 
              id="payment-term"
              ref="payment-term"
              :modal="false"
              :title="'viewTitle'"
              :salePrice="dataSalePrice"
              :discount="dataDiscount"
              v-model="selectChangePaymentTerm"
            /> 
          </div>
        </div>
      </div>

      <div class="col-lg-3">

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
              </div>
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
              </div>
            </div>

          </div>
        </div>

      </div>
    </b-form> 

  </Layout>
</template>